import { render } from "./expand.vue?vue&type=template&id=4bc4c342&scoped=true"
import script from "./expand.vue?vue&type=script&lang=js"
export * from "./expand.vue?vue&type=script&lang=js"

import "./expand.vue?vue&type=style&index=0&id=4bc4c342&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc4c342"]])

export default __exports__